import { TableRow } from "@mui/material";
import { type Ref, forwardRef } from "react";
import type { ItemProps as VirtuosoItemProps } from "react-virtuoso";
import { useTableVirtualizedContext } from "./context";

export const VirtuosoTableRow = forwardRef(function VirtuosoTableRow<Data>(
  { children, ...props }: VirtuosoItemProps<Data>,
  ref: Ref<HTMLTableRowElement>
) {
  const { slotProps } = useTableVirtualizedContext();

  return (
    <TableRow {...props} ref={ref} {...slotProps?.tableRow}>
      {children}
    </TableRow>
  );
});
